enum VideoStartType {
  Open = "open",
  Start = "start",
}

export { VideoStartType };